var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Helpers from './../helpers/utility';
import { lazy } from './';
var getArgList = Helpers.getArgList;
/**
 * Given an object, replace the named methods with lazy versions of the same method.
 * Returns a map to the lazy functions - which you will need for property getters since there's
 * no way to access the "clear" control otherwise
 *
 * @param {object} target The target
 * @param {any} methods An array of methods, or a function which will filter methods on the object
 * @returns {Map} A map of [name, wrapper] that contains the lazy instance for each method.
 */
export default function makeLazy(target, methods) {
    if (methods === void 0) { methods = []; }
    var propNames = getArgList(methods);
    var filter = typeof propNames === 'function' ?
        propNames :
        function (name) {
            return propNames.includes(name);
        };
    var props = reflect(target, filter);
    var x = props.map(function (_a) {
        var name = _a[0], data = _a[1];
        if (data.field) {
            if (typeof target[name] === 'function') {
                var wrapped = lazy(target[name]);
                target[name] = wrapped;
                return [name, wrapped];
            }
            else {
                throw new Error();
            }
        }
        else {
            var wrapped = lazy(data.get);
            Object.defineProperty(target, name, {
                configurable: true,
                enumerable: data.enumerable,
                get: wrapped,
                set: data.set
            });
            return [name, wrapped];
        }
    });
    return new Map(x);
}
function reflect(obj, filter) {
    var props = getPropertyDescriptors(obj);
    if (filter) {
        props = props.filter(function (e) { return filter(e.memberName); });
    }
    return props.map(function (_a) {
        var memberName = _a.memberName, descriptor = _a.descriptor;
        var hasValue = descriptor.hasOwnProperty('value');
        return [memberName, {
                field: hasValue,
                get: descriptor.get,
                set: descriptor.set,
                enumerable: descriptor.enumerable
            }];
    });
}
function getPropertyDescriptors(obj) {
    var props = Object.getOwnPropertyNames(obj)
        .filter(function (name) { return name !== 'constructor'; })
        .map(function (name) { return ({ memberName: name, descriptor: Object.getOwnPropertyDescriptor(obj, name) }); });
    var parentProto = Object.getPrototypeOf(obj);
    if (parentProto !== Object.prototype) {
        props = __spreadArrays(props, getPropertyDescriptors(parentProto));
    }
    return props;
}
//# sourceMappingURL=make-lazy.js.map